/*
# 测试环境 乐年本地地址
# VUE_APP_BASE_API = 'http://192.168.0.120:8080'
# VUE_APP_BASE_API = 'http://192.168.3.29:8080'
# 测试环境
VUE_APP_BASE_API = 'http://120.77.31.213:8080'
# 场外测试环境
# VUE_APP_BASE_API = 'http://47.112.174.103:8081'
# 测试环境
# VUE_APP_BASE_API = 'http://120.77.31.213:8080'
# 正式地址https
# VUE_APP_BASE_API = 'https://dp.zanecon.cn/api'
*/

// let develop = "http://120.77.31.213:8080"
// let online = "https://dp.zanecon.cn/api"
let develop = "https://dp.zanecon.cn/api"
let online = "https://dp.zanecon.cn/api"


// let develop = "http://192.168.3.46:8080"	//邓华本地地址


export default {
	develop,
	online
}



// WEBPACK FOOTER //
// ./src/url.js